// Matches dates in YYYY-MM-DD format
export const dateStrFormatRegex = /^\d{4}-(\d{1}|\d{2})-(\d{1}|\d{2})$/;

export const dateStrRegex = /^\d{4}-(([1-9])|(0[1-9]|1[0-2]))-(([1-9])|(0[1-9]|[12][0-9]|3[01]))$/;

// https://www.regular-expressions.info/email.html
// allow lower case, multiple domains, and at least one character after the last dot.
// STORIS uses 0X@0X.0X for its matching pattern.
export const emailRegex = /[a-zA-Z0-9._%+-]@(?:[a-zA-Z0-9-]+\.)[a-zA-Z]{1,}/;

export const zipPostalRegex = /(^\d{5}$)|(^\d{9}$)|(^\d{5}-\d{4}$)/; // /^\d{5}(?:[-\s]\d{4})?$/;
